import {
  MappedConfigurationUser,
  mapUsersToFullName
} from '@hkm/components/TaskManagement/Dashboard/mappers';

import {
  ConfigurationUser,
  FilterQueryParams,
  getDataForAllPages,
  PageQueryParams,
  PageResponse,
  RawConfigurationUser,
  RawTaskStatus,
  TaskStatus
} from '@ac/library-api';
import { TaskStatusApi } from '@ac/library-api/dist/api/v0/configuration/genericEntities';
import { ConfigurationUsersApi } from '@ac/library-api/dist/api/v0/configuration/users';

export const getAllTaskStatuses = async (
  filter?: FilterQueryParams
): Promise<TaskStatus[]> => {
  return (
    await getDataForAllPages(
      ({ pageNumber, pageSize }: PageQueryParams) =>
        TaskStatusApi.getList({
          queryParams: { pageNumber, pageSize, ...filter }
        }) as Promise<PageResponse<RawTaskStatus, TaskStatus>>
    )
  ).results;
};

export const getConfigurationUsers = async (
  filter?: FilterQueryParams
): Promise<MappedConfigurationUser[]> => {
  const users: PageResponse<
    RawConfigurationUser,
    ConfigurationUser
  > = await getDataForAllPages(
    ({ pageNumber, pageSize }: PageQueryParams) =>
      ConfigurationUsersApi.getUsers({
        queryParams: { pageNumber, pageSize, ...filter }
      }) as Promise<PageResponse<RawConfigurationUser, ConfigurationUser>>
  );

  return mapUsersToFullName(users.results);
};



// WEBPACK FOOTER //
// ./src/components/TaskManagement/apis/configuration.ts